import { lazy } from 'react';
import { UserTypes } from '@/configs/AppConfig';
import { MOD_TBL_CALCULATIONS } from '@/configs/ModulesConfig';
import { Navigate } from "react-router-dom";

const TBLCalculationForm = lazy(() => import('./TBLCalculationForm'));
const TBLCalculationList = lazy(() => import('./TBLCalculationList'));
const TBLCalculationNameForm = lazy(() => import('./TBLCalculationNameForm'));


const route = [
    {
        path: MOD_TBL_CALCULATIONS.base_path,
        element: <Navigate to={MOD_TBL_CALCULATIONS.routes.list} replace />,
        auth: MOD_TBL_CALCULATIONS.auth
    },
    {
        path: MOD_TBL_CALCULATIONS.routes.list,
        element: <TBLCalculationList />,
        auth: MOD_TBL_CALCULATIONS.auth
    },
    {
        path: MOD_TBL_CALCULATIONS.routes.mod_edit,
        element: <Navigate to={MOD_TBL_CALCULATIONS.routes.edit_name} replace />,
        auth: MOD_TBL_CALCULATIONS.auth
    },
    {
        path: MOD_TBL_CALCULATIONS.routes.mod_edit_name,
        element: <TBLCalculationNameForm />,
        auth: MOD_TBL_CALCULATIONS.auth
    },
    {
        path: MOD_TBL_CALCULATIONS.routes.edit_name,
        element: <TBLCalculationNameForm />,
        auth: MOD_TBL_CALCULATIONS.auth
    },
    {
        path: MOD_TBL_CALCULATIONS.routes.edit,
        element: <TBLCalculationForm />,
        auth: MOD_TBL_CALCULATIONS.auth
    }
];



export default route;